import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import('@/layouts/Default'),
    children: [
      {
        path: '/',
        component: () => import('@/views/home/Home.vue'),
        name: 'Principal',
        meta: {
          title: 'Neuro MS - Home',
          noCache: true
        }
      },
      {
        path: 'pacientes',
        component: () => import('@/views/pacientes/Pacientes.vue'),
        name: 'Pacientes',
        meta: {
          title: 'Neuro MS - Pacientes',
          noCache: true
        }
      },
      {
        path: 'medicos',
        component: () => import('@/views/medicos/Medicos.vue'),
        name: 'Médicos',
        meta: {
          title: 'Neuro MS - Medicos',
          noCache: true
        }
      },
      {
        path: 'recepcionistas',
        component: () => import('@/views/recepcionistas/Recepcionistas.vue'),
        name: 'Recepcionistas',
        meta: {
          title: 'Neuro MS - Recepcionistas',
          noCache: true
        }
      },
      {
        path: 'supervisores',
        component: () => import('@/views/supervisores/Supervisores.vue'),
        name: 'Supervisores',
        meta: {
          title: 'Neuro MS - Supervisores',
          noCache: true
        }
      },
      {
        path: 'convenios',
        component: () => import('@/views/convenios/Convenios.vue'),
        name: 'Convênios',
        meta: {
          title: 'Neuro MS - Convenios',
          noCache: true
        }
      },
      {
        path: 'unidades',
        component: () => import('@/views/unidades/Unidades.vue'),
        name: 'Unidades Médicas',
        meta: {
          title: 'Neuro MS - Unidades',
          noCache: true
        }
      },
      {
        path: 'especialidades',
        component: () => import('@/views/especialidades/Especialidades.vue'),
        name: 'Especialidades',
        meta: {
          title: 'Neuro MS - Especialidades',
          noCache: true
        }
      },
      {
        path: 'procedimentos',
        component: () => import('@/views/procedimentos/Procedimentos.vue'),
        name: 'Procedimentos',
        meta: {
          title: 'Neuro MS - Procedimentos',
          noCache: true
        }
      },
      {
        path: 'agenda',
        component: () => import('@/views/agenda/Agenda.vue'),
        name: 'Agenda',
        meta: {
          title: 'Neuro MS - Agenda',
          noCache: true
        }
      },
      {
        path: 'exames',
        component: () => import('@/views/examesDoDia/ExamesDoDia.vue'),
        name: 'Exames do Dia',
        meta: {
          title: 'Neuro MS - Exames do Dia',
          noCache: true
        }
      },
      {
        path: 'minhaAgenda',
        component: () => import('@/views/minhaAgenda/MinhaAgenda.vue'),
        name: 'Minha Agenda',
        meta: {
          title: 'Neuro MS - Minha Agenda',
          noCache: true
        }
      },
      {
        path: 'meusHorarios',
        component: () => import('@/views/meusHorarios/MeusHorarios.vue'),
        name: 'Meus Horarios',
        meta: {
          title: 'Neuro MS - Meus Horarios',
          noCache: true
        }
      },
      {
        path: 'modelosTecnicos',
        component: () => import('@/views/modelosTecnicos/ModelosTecnicos.vue'),
        name: 'Modelos Técnicos',
        meta: {
          title: 'Neuro MS - Modelos Técnicos',
          noCache: true
        }
      },
      {
        path: 'atendimentosDoDia',
        component: () => import('@/views/atendimentosDoDia/AtendimentosDoDia.vue'),
        name: 'Atendimentos do Dia',
        meta: {
          title: 'Neuro MS - Atendimentos do Dia',
          noCache: true
        }
      },
      {
        path: 'procedimentosDoDia',
        component: () => import('@/views/procedimentosDoDia/ProcedimentosDoDia.vue'),
        name: 'Procedimentos do Dia',
        meta: {
          title: 'Neuro MS - Procedimentos do Dia',
          noCache: true
        }
      },
      {
        path: 'resultadoExames',
        component: () => import('@/views/resultadoExames/ResultadoExames.vue'),
        name: 'Resultado de Exames',
        meta: {
          title: 'Neuro MS - Resultado de Exames',
          noCache: true
        }
      },
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/Login.vue'),
    meta: {
      title: 'Neuro MS - Login',
      noCache: true
    }
  }
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
})

export default router
